package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class BudgetEntity(
  public val categoryId: String,
  public val limitCents: Long,
  public val isDeleted: Boolean,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
